export const YEAR_BUILT_OPTIONS = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, index) => ({
    label: String(1900 + index),
    value: 1900 + index,
  }),
);
